var _path, _g, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8205 19.7001C17.7312 18.6059 18.6368 17.6924 19.7215 17.7825C19.9096 17.7981 20.1348 17.8666 20.3641 17.9363C20.3862 17.943 20.4083 17.9497 20.4304 17.9564C20.4504 17.9624 20.4704 17.9685 20.4904 17.9745C20.7012 18.0378 20.9108 18.1008 21.0702 18.1869C21.9855 18.6813 22.2809 19.8626 21.7077 20.7358C21.6078 20.8879 21.4529 21.0436 21.2972 21.2003C21.2824 21.2151 21.2677 21.23 21.2529 21.2449C21.2382 21.2598 21.2234 21.2747 21.2087 21.2896C21.0534 21.4467 20.899 21.6029 20.7482 21.7036C19.8826 22.2819 18.7115 21.9838 18.2214 21.0606C18.136 20.8998 18.0736 20.6883 18.0108 20.4758C18.0048 20.4556 17.9988 20.4354 17.9928 20.4152C17.9862 20.3929 17.9795 20.3706 17.9729 20.3483C17.9038 20.117 17.8359 19.8898 17.8205 19.7001Z",
    fill: "#98A1B7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1566 20.3133C16.2137 20.3133 20.3133 16.2137 20.3133 11.1566C20.3133 6.09956 16.2137 2 11.1566 2C6.09956 2 2 6.09956 2 11.1566C2 16.2137 6.09956 20.3133 11.1566 20.3133Z",
    fill: "#98A1B7"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.02344 11.1565C8.02344 10.7572 8.34709 10.4336 8.74633 10.4336H13.5656C13.9648 10.4336 14.2885 10.7572 14.2885 11.1565C14.2885 11.5557 13.9648 11.8794 13.5656 11.8794H8.74633C8.34709 11.8794 8.02344 11.5557 8.02344 11.1565Z",
    fill: "#61739F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/ZoomOut.0bdcb94e744ee673b0af7c65af7b7fad.svg";
export { ForwardRef as ReactComponent };